<template>
  <div>
    <Menu />
    <div class="container main atualizar-cadastro">
      <ValidationObserver ref="form">
        <div class="row">
          <div class="col-md-12">
            <SectionTitle
              title="Atualizar cadastro"
              description="Atualizar dados e alterar senha"
              url="/dashboard"
            />
          </div>
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="email">
              <div class="error">{{ errors[0] }}</div>
              <label for="">E-MAIL</label>
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-envelope"></i>
                  </span>
                </div>
                <input
                  name="email"
                  v-model="email"
                  class="form-control"
                  placeholder="E-MAIL"
                  type="email"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="">
              <div class="error">{{ errors[0] }}</div>
              <label for="">TELEFONE</label>
              <div class="form-group input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">
                    <i class="icofont-phone"></i>
                  </span>
                </div>
                <the-mask
                  :mask="['(##) ####-####', '(##) #####-####']"
                  v-model="telefone"
                  required
                  class="form-control"
                  placeholder="TELEFONE"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="password">
              <!-- <div class="error">{{ errors[0] }}</div> -->
              <label for="">NOVA SENHA</label>
              <div class="form-group input-group">
                <div
                  class="input-group-prepend"
                  @click="showPassword = !showPassword"
                  style="cursor: pointer"
                >
                  <span class="input-group-text">
                    <i
                      :class="
                        showPassword ? 'icofont-eye-blocked' : 'icofont-eye'
                      "
                    ></i>
                  </span>
                </div>
                <input
                  name="senha"
                  v-model="senha"
                  class="form-control"
                  placeholder=""
                  :type="showPassword ? 'text' : 'password'"
                />
              </div>
              <div class="mt-2 mb-2">
                <ul>
                  <li :class="colorLenght">
                    <i :class="lenghtPassword"></i> 8 ou mais caracteres;
                  </li>
                  <li :class="colorLetters">
                    <i :class="lettersPassword"></i> 1 ou mais letras
                    maiúsculas;
                    <span
                      v-b-tooltip.hover
                      title="A B C D E F G H I J K L M N O P Q R S T U V W X Y Z"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </li>
                  <li :class="colorNumbers">
                    <i :class="numbersPassword"></i> 1 ou mais números;
                    <span
                      v-b-tooltip.hover
                      title="1 2 3 4 5 6 7 8 9 0"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </li>
                  <li :class="colorSpecialChars">
                    <i :class="SpecialCharsPassword"></i> 1 ou mais caracteres
                    especiais.
                    <span
                      v-b-tooltip.hover
                      title="Exemplos de caracteres especiais: ! @ # $ % ^ & * ( ) _ + \ - = [ \ ] { } ; : \ \ | , . < > / ? ~"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </li>
                </ul>
              </div>
            </validation-provider>
          </div>
          <div class="col-md-6 col-12">
            <validation-provider v-slot="{ errors }" rules="password">
              <!-- <div class="error">{{ errors[0] }}</div> -->
              <label for="">CONFIRMAR NOVA SENHA</label>
              <div class="form-group input-group">
                <div
                  class="input-group-prepend"
                  @click="showConfirmedPassword = !showConfirmedPassword"
                >
                  <span class="input-group-text">
                    <i
                      :class="
                        showConfirmedPassword
                          ? 'icofont-eye-blocked'
                          : 'icofont-eye'
                      "
                    ></i>
                  </span>
                </div>
                <input
                  name="confirmarsenha"
                  v-model="confirmarsenha"
                  class="form-control"
                  placeholder=""
                  :type="showConfirmedPassword ? 'text' : 'password'"
                />
              </div>
            </validation-provider>
          </div>
          <div class="col-12">
            <button
              type="submit"
              class="btn float-right"
              style="color: #fff"
              v-on:click="atualizar()"
            >
              Atualizar
              <b-spinner
                label="Spinning"
                small
                variant="white"
                v-if="loading"
              ></b-spinner>
            </button>
          </div>
        </div>
      </ValidationObserver>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import { TheMask } from 'vue-the-mask'
import { mapState } from 'vuex'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import SectionTitle from '@/components/SectionTitle'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()

export default {
  name: 'AtualizarCadastro',
  components: {
    Menu,
    Footer,
    TheMask,
    PulseLoader,
    SectionTitle,
    ValidationObserver,
    ValidationProvider,
  },
  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      cidades: [],
      estado: '',
      cidade: '',
      nome: '',
      cpf: '',
      email: '',
      funcao: '',
      telefone: '',
      senha: '',
      confirmarsenha: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
      showPassword: false,
      showConfirmedPassword: false,
    }
  },
  created() {
    this.buscarUsuario()
  },
  computed: {
    ...mapState(['user']),
    colorLenght() {
      if (this.senha.length < 8) {
        return 'red'
      }
      return 'green'
    },
    lenghtPassword() {
      if (this.senha.length < 8) {
        return 'icofont-close'
      }
      return 'icofont-check'
    },
    colorNumbers() {
      if (/\d/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    numbersPassword() {
      if (/\d/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorLetters() {
      if (/[A-Z]/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    lettersPassword() {
      if (/[A-Z]/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
    colorSpecialChars() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.senha)) {
        return 'green'
      }
      return 'red'
    },
    SpecialCharsPassword() {
      if (/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.senha)) {
        return 'icofont-check'
      }
      return 'icofont-close'
    },
  },
  methods: {
    buscarUsuario() {
      this.$api
        .get(
          '/app/buscar-usuario-card-atualizar-cadastro/' + this.$store.state.id
        )
        .then((response) => {
          this.estado = response.data.no_uf
          this.cidade = response.data.cod_ibge
          this.nome = response.data.nome
          this.cpf = response.data.cpf
          this.email = response.data.email
          this.funcao = response.data.funcao
          this.telefone = response.data.telefone
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    buscarCidades(estado) {
      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeEstados(event) {
      let estado = event.target.value
      this.$apiPublic
        .get('/cidades-por-uf/' + estado)
        .then((response) => {
          this.cidades = response.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    onChangeCidades(event) {
      this.cidade = event.target.value
    },

    async atualizar() {
      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        return false
      }

      if (this.senha == this.confirmarsenha) {
        this.loading = true
        const usuario = {
          nome: this.nome,
          email: this.email,
          telefone: this.telefone,
          senha: this.senha,
          id: this.$store.state.id,
        }
        this.$api
          .post('/app/atualizar-usuario', usuario)
          .then((response) => {
            if (response.data.error == true) {
              this.$toast.error(response.data.message, 'Error:', {
                position: 'topRight',
              })
            } else {
              this.$toast.success(response.data.message, 'Sucesso:', {
                position: 'topRight',
              })
            }
          })
          .catch(function (error) {
            console.log(error)
            this.$toast.error(
              'Por favor, entre em contato com o suporte.',
              'Error:',
              {
                position: 'topRight',
              }
            )
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.$toast.error('As senhas não conferem!', 'Error:', {
          position: 'topRight',
        })
      }
    },
  },
}
</script>

<style>
.atualizar-cadastro h3 {
  margin-bottom: 25px;
}
.atualizar-cadastro label {
  display: block;
  width: 100%;
}
</style>
